import Cookie from 'js-cookie'

import { SignupState, SignupCodeInfo } from 'types'

export const initialState: SignupState = {
  signupCodeInfo: {},
  selectedRefCode: '',
  userCountry: Cookie.get('country') || '',
}

type SelectRefCode = {
  type: 'SELECT_REF_CODE'
  data: string
}

type FetchUserCountryDone = {
  type: 'FETCH_USER_COUNTRY_DONE'
  data: {
    response: string
  }
}

type FetchInfoForCode = {
  type: 'FETCH_INFO_FOR_CODE_DONE'
  data: {
    response: SignupCodeInfo
    code: string
  }
}

type SignupDoneActions = SelectRefCode | FetchUserCountryDone | FetchInfoForCode

const reducer = (state: SignupState = initialState, action: SignupDoneActions): SignupState => {
  switch (action.type) {
    case 'SELECT_REF_CODE': {
      return {
        ...state,
        selectedRefCode: action.data,
      }
    }
    case 'FETCH_USER_COUNTRY_DONE': {
      const {
        data: { response: country },
      } = action
      if (country && typeof country === 'string') {
        Cookie.set('country', country)
        return {
          ...state,
          userCountry: country,
        }
      }
      return state
    }

    case 'FETCH_INFO_FOR_CODE_DONE': {
      const {
        data: { response, code },
      } = action
      return {
        ...state,
        signupCodeInfo: {
          ...state.signupCodeInfo,
          [code]: {
            ...response,
          },
        },
      }
    }
    default:
      return state
  }
}
export default reducer
